import _isEmpty from "lodash/isEmpty";
import { mapState, mapGetters, mapActions } from "vuex";
import { gtmTrigger } from "@/util/gtm";


export default {
	beforeRouteEnter(to, from, next) {
		const hasVariantId = (localStorage.getItem("starter_variant_id") !== null);
		if (!hasVariantId) {
			next({ name: "starter-series" });
		} else {
			next();
		}
	},
	data() {
		return {
			isReady: true
		};
	},
	computed: {
		...mapState({
			cartHasBeenInitialized: (state) => (!_isEmpty(state.PrebuildSeries.cart)),
			rules: state => state.PrebuildSeries.rules
		}),
		...mapGetters({
			accessories: "PrebuildSeries/getSeriesAccessories",
			currentAccessories: "PrebuildSeries/getCurrentAccessories",
			cartInfo: "PrebuildSeries/getCartInfo",
			seriesInfo: "PrebuildSeries/getSeriesInfo",
			seriesPrebuilds: "PrebuildSeries/getSeriesPrebuilds",
			userShipping: "userShipping",
			userCurrency: "userCurrency"
		}),
		orderedAccessories() {
			return {
				"storage": this.accessories.storage,
				"extras": this.accessories.extras,
				"peripherals": this.accessories.peripherals,
				"monitors": this.accessories.monitors
			};
		},
		prebuildVariantHasChanged() {
			if (this.cartHasBeenInitialized) {
				return this.prebuildVariantInCart.id === localStorage.getItem("starter_variant_id");
			}

			return false;
		},
		prebuildInCart() {
			if (this.cartHasBeenInitialized) {
				return this.seriesPrebuilds.find(prebuild => prebuild.id === this.cartInfo.build.prebuild_id);
			}
			return {};
		},
		prebuildVariantInCart() {
			if (this.cartHasBeenInitialized && !_isEmpty(this.prebuildInCart)) {
				return this.prebuildInCart.variants.find(variant => (variant.id === this.cartInfo.build.prebuild_variant_id));
			}
			return {};
		},
		prebuildParts() {
			if (!_isEmpty(this.prebuildVariantInCart)) {
				return this.prebuildVariantInCart.details;
			}

			return {};
		},
		isPreBuildInStock() {
			return this.prebuildVariantInCart.is_in_stock;
		},
		totalCartPrice() {
			if (this.cartHasBeenInitialized) {
				return this.cartInfo.total;
			}

			return 0;
		},
		shippingInfo() {
			if (!_isEmpty(this.seriesInfo)) {
				const { sections = [] } = this.seriesInfo;
				const [firstSection = {}] = sections;
				return firstSection.body || "";
			}

			return "";
		},
		seriesAccessories() {
			if (this.cartHasBeenInitialized) {
				return this.accessories;
			}

			return {};
		},
		currentAccessoriesCart() {
			if (this.cartHasBeenInitialized) {
				return this.currentAccessories;
			}

			return {};
		},
		gtmPrebuildVariables() {
			return {
				pcSKU: this.prebuildVariantInCart.sku,
				pcName: this.prebuildInCart.name,
				pcPrice: this.prebuildVariantInCart.price,
				pcColor: Array.isArray(this.prebuildVariantInCart.colors)
					? this.prebuildVariantInCart.colors[0]
					: undefined
			};
		}
	},
	created() {
		if (!this.cartHasBeenInitialized && _isEmpty(this.seriesPrebuilds)) {
			this.setPrebuildData();
		}
	},
	beforeMount() {
		window.addEventListener("beforeunload", this.checkNavigation);
	},
	beforeDestroy() {
		window.removeEventListener("beforeunload", this.checkNavigation);
	},
	watch: {
		rules(list) {
			if (!_isEmpty(list)) {
				const rulesText = [];

				list.forEach(item => {
					if (!["enable", "disabled"].includes(item.ruleType)) {
						rulesText.push(item.msg);
					}
				});

				if (rulesText.length) {
					this.$modal.show("ruleModal", {
						title: "Error",
						content: rulesText.join("<br>")
					});
				}
			}
		}
	},
	methods: {
		...mapActions({
			setRules: "PrebuildSeries/setRules",
			fetchSeriesInfo: "PrebuildSeries/fetchSeriesInfo",
			fetchSeriesPrebuilds: "PrebuildSeries/fetchSeriesPrebuilds",
			setPrebuildSeries: "PrebuildSeries/setPrebuildSeries",
			initSeriesCart: "PrebuildSeries/initSeriesCart",
			getSeriesCart: "PrebuildSeries/getSeriesCart",
			setAppLoader: "Application/setShowLoading"
		}),
		async setPrebuildData() {
			this.setIsReady(false);

			const seriesInfo = await this.fetchSeriesInfo({ name: "starter-line" });
			const prebuilds = await this.fetchSeriesPrebuilds({ seriesInfo });
			const isSeriesSartInitialized = localStorage.getItem("series-cart-Initialized");
			this.setPrebuildSeries({ seriesInfo, prebuilds });

			const checkPrebuild = () => {
				const starterVariantId = localStorage.getItem("starter_variant_id");
				const starterPrebuildSlug = localStorage.getItem("starter_prebuild_slug");

				if (!starterVariantId && !starterPrebuildSlug) {
					localStorage.setItem("starter_prebuild_slug", prebuilds[0].slug);
					localStorage.setItem("starter_variant_id", prebuilds[0].variants[0].id);
				}

				return starterVariantId;
			};

			!isSeriesSartInitialized ? this.initSeriesCart(checkPrebuild()) : this.getSeriesCart();

			this.setIsReady(true);
		},
		setIsReady(payload) {
			const setLoader = !payload;
			this.setAppLoader(setLoader);

			this.isReady = payload;
		},
		trackContinueToCart(buttonPosition) {
			const cartAccessories = [];
			for (const type in this.accessories) {
				const accessories = (this.accessories[type] || []).reduce((acc, accessory) => {
					const cartAccessory = this.currentAccessories.find(({ product_id: productID }) => productID == accessory.id);
					if (cartAccessory) {
						const { sku, price, title, colors, capacity } = accessory.variants.find(({ id }) => id == cartAccessory.variant_id);
						let variant = colors && colors.length ? colors[0] : undefined;
						if (type == "storage") {
							variant = capacity;
						}
						acc.push({
							id: sku,
							name: title,
							price,
							category: `prebuilds/${this.prebuildInCart.slug}/accessories/${type}`,
							variant,
							quantity: cartAccessory.quantity
						});
					}
					return acc;
				}, []);
				cartAccessories.push(...accessories);
			}
			gtmTrigger.addToCart(cartAccessories, buttonPosition, this.userCurrency);
		},
		checkNavigation() {
			sessionStorage.setItem("last-prebuild-in-checkout-flow", JSON.stringify({
				path: this.$route.path,
				group: this.$route.meta.group
			}));
		}
	}
};